import React from "react";
import { MONTHLY_PHONE_CONSULTATION_PROGRAMS } from "./monthlyPhoneConsultationLabels";

const PROGRAM_OPTIONS = [
  MONTHLY_PHONE_CONSULTATION_PROGRAMS.rpm,
  MONTHLY_PHONE_CONSULTATION_PROGRAMS.ccm
];

const ProgramTypeSelector = ({ onSelect }) => (
  <div className="mpc-program-selector-shell">
    <div className="mpc-program-selector-card">
      <div className="mpc-program-selector-header">
        <h4>Choose a program to review</h4>
        <p>
          Monthly Phone Consultations are tracked separately for RPM and CCM. Select which program
          you want to review.
        </p>
      </div>

      <div className="mpc-program-selector-grid">
        {PROGRAM_OPTIONS.map((option) => (
          <button
            key={option.key}
            type="button"
            className={`mpc-program-selector-option mpc-program-selector-option--${option.key}`}
            onClick={() => onSelect(option.key)}
          >
            <span className={`mpc-program-selector-badge ${option.label}`}>{option.label}</span>
            <span className="mpc-program-selector-title">{option.shortTitle}</span>
            <span className="mpc-program-selector-description">{option.description}</span>
            <span className="mpc-program-selector-cta">
              Review {option.label} consultations
              <i className="mdi mdi-arrow-right" aria-hidden="true" />
            </span>
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default ProgramTypeSelector;
